export class Scrolling {
  isScrollingEnabled: boolean
  scrollBarWidth = 0

  constructor() {
    this.isScrollingEnabled = true
  }

  getScrollBarWidth() {
    if (this.isScrollingEnabled && typeof document !== "undefined") {
      if (!this.scrollBarWidth) {
        this.calculateScrollBarWidth()
      }
      return this.scrollBarWidth
    }
    return 0
  }

  disable() {
    document.body.style.overflowY = "hidden"
    document.body.style.marginRight = `${this.getScrollBarWidth()}px`
    this.isScrollingEnabled = false
  }

  enable() {
    document.body.style.overflowY = "scroll"
    document.body.style.marginRight = ""
    this.isScrollingEnabled = true
  }

  calculateScrollBarWidth() {
    const div = document.createElement("div")
    div.setAttribute(
      "style",
      "width: 100px; height: 100px; overflow: scroll; position: absolute; top: -9999px;",
    )
    document.body.appendChild(div)
    const scrollBarWidth = div.offsetWidth - div.clientWidth
    document.body.removeChild(div)
    this.scrollBarWidth = scrollBarWidth
  }
}

export const scrolling = new Scrolling()
